import { render, staticRenderFns } from "./PartnersBLock.vue?vue&type=template&id=552e191a&scoped=true"
import script from "./PartnersBLock.vue?vue&type=script&lang=js"
export * from "./PartnersBLock.vue?vue&type=script&lang=js"
import style0 from "./PartnersBLock.vue?vue&type=style&index=0&id=552e191a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552e191a",
  null
  
)

export default component.exports